var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76228 2.41219L1.64594 7.70637C1.55647 7.79943 1.45011 7.87328 1.33298 7.92367C1.21584 7.97406 1.09023 8 0.963375 8C0.836518 8 0.710911 7.97406 0.593774 7.92367C0.476636 7.87328 0.370278 7.79943 0.280809 7.70637C0.100936 7.51769 8.97421e-05 7.26331 8.97421e-05 6.99827C8.97421e-05 6.73324 0.100936 6.47886 0.280809 6.29018L6.07738 0.29091C6.2533 0.109704 6.48992 0.00559697 6.73808 0.00021919C6.98624 -0.00515859 7.22687 0.0886062 7.40996 0.262032L13.2461 6.28777C13.4276 6.47509 13.5297 6.72934 13.53 6.99459C13.5304 7.25984 13.4288 7.51436 13.2478 7.70216C13.0668 7.88996 12.8211 7.99565 12.5647 7.99599C12.3084 7.99633 12.0624 7.89129 11.8809 7.70396L6.76228 2.41219Z",
    fill: "#213345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedIcon);
export default __webpack_public_path__ + "static/media/Collapsed-icon.1e35ade6259e48c5f7c1a0a0905dcd35.svg";
export { ForwardRef as ReactComponent };